"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactOnScreen = _interopRequireDefault(require("react-on-screen"));

var _ExpandButton = _interopRequireDefault(require("./ExpandButton"));

var _SubrowButton = _interopRequireWildcard(require("./SubrowButton"));

var _TextFormatter = _interopRequireDefault(require("./formatters/TextFormatter"));

var _SortIcon = require("./SortIcon");

var _ColumnPropTypes = _interopRequireDefault(require("./ColumnPropTypes"));

var _Checkbox = _interopRequireDefault(require("../../elements/form/elements/Checkbox"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RowDiv = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex align-items-center px-2 bcr-table-row"
  };
}).withConfig({
  displayName: "Row__RowDiv",
  componentId: "sc-1gkwg2w-0"
})(["height:", "px;background:", ";border-bottom:1px solid ", ";", ";", ";&:hover{", ";}"], function (props) {
  return props.height;
}, function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["grey"];
}, function (props) {
  return props.expanded && "box-shadow: 0px 20px 15px -15px silver";
}, function (props) {
  return props.onClick && "cursor: pointer";
}, function (props) {
  return props.onClick && "background: ".concat(props.theme["grey-three"]);
});

var BodyCell = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex align-items-center bcr-table-body-cell"
  };
}).withConfig({
  displayName: "Row__BodyCell",
  componentId: "sc-1gkwg2w-1"
})(["width:", "px;height:", "px;", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.sorted ? "background: ".concat(props.theme["grey-three"]) : "";
});

var ExpansionHolder = _styledComponents["default"].div.withConfig({
  displayName: "Row__ExpansionHolder",
  componentId: "sc-1gkwg2w-2"
})(["border-bottom:1px solid ", ";"], function (props) {
  return props.theme["grey"];
});

var CheckboxHolder = _styledComponents["default"].div.attrs(function () {
  return {
    className: "mr-3 d-flex bcr-table-body-cell"
  };
}).withConfig({
  displayName: "Row__CheckboxHolder",
  componentId: "sc-1gkwg2w-3"
})(["min-width:1.0625rem;"]);

var DefaultRow = function DefaultRow(_ref) {
  var rowHeight = _ref.rowHeight,
      _ref$rowStyle = _ref.rowStyle,
      rowStyle = _ref$rowStyle === void 0 ? {} : _ref$rowStyle;
  return _react["default"].createElement("div", {
    style: _objectSpread({
      height: rowHeight
    }, rowStyle)
  });
};

DefaultRow.propTypes = {
  rowHeight: _propTypes["default"].number.isRequired,
  rowStyle: _propTypes["default"].object
};
DefaultRow.defaultProps = {
  rowStyle: {}
};

var RowData = function RowData(_ref2) {
  var index = _ref2.index,
      rowPrefix = _ref2.rowPrefix,
      rowStyle = _ref2.rowStyle,
      rowHeight = _ref2.rowHeight,
      expanded = _ref2.expanded,
      columns = _ref2.columns,
      sortColumn = _ref2.sortColumn,
      sortDirection = _ref2.sortDirection,
      value = _ref2.value,
      hasSubRows = _ref2.hasSubRows,
      columnSizes = _ref2.columnSizes,
      expansion = _ref2.expansion,
      displayExpansionButton = _ref2.displayExpansionButton,
      recompute = _ref2.recompute,
      tableExpanded = _ref2.tableExpanded,
      expandable = _ref2.expandable,
      subRowStylesGetter = _ref2.subRowStylesGetter,
      showCheckbox = _ref2.showCheckbox,
      isRowSelected = _ref2.isRowSelected,
      onRowSelectionChange = _ref2.onRowSelectionChange,
      isRowDisabled = _ref2.isRowDisabled,
      canSelect = _ref2.canSelect,
      expandCallback = _ref2.expandCallback,
      onRowClick = _ref2.onRowClick;
  var ExpansionElement = expansion;

  var expand = function expand() {
    recompute(index);
    tableExpanded(index, !expanded, value);
  };

  var shouldShowSubRows = !!expanded && !!hasSubRows || !expandable;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(RowDiv, {
    height: rowHeight,
    style: rowStyle,
    expanded: expanded,
    onClick: onRowClick ? function () {
      return onRowClick(index, value);
    } : null
  }, showCheckbox ? _react["default"].createElement(CheckboxHolder, null, _react["default"].createElement(_Checkbox["default"], {
    label: "",
    checked: isRowSelected,
    onChange: function onChange() {
      onRowSelectionChange(value, !isRowSelected);
    },
    disabled: isRowDisabled || !canSelect(value)
  })) : null, !!expansion && displayExpansionButton && _react["default"].createElement(_ExpandButton["default"], {
    expanded: expanded,
    onClick: function onClick() {
      return expand();
    }
  }), !!hasSubRows && !!expandable && _react["default"].createElement(_SubrowButton["default"], {
    isVisible: !!value.subRows && value.subRows.length > 0 ? "visible" : "hidden",
    expanded: expanded,
    onClick: function onClick() {
      expandCallback(index, value, !expanded);
      recompute(index);
      tableExpanded(index, !expanded, value);
    },
    disabled: isRowDisabled
  }), columns.map(function (col, index) {
    var Formatter = col.formatter ? col.formatter : _TextFormatter["default"];
    var sorted = sortDirection !== _SortIcon.NO_DIRECTION && sortColumn === col.name;
    var width = columnSizes[index] ? columnSizes[index] : col.width;
    return _react["default"].createElement(BodyCell, {
      height: rowHeight,
      width: width,
      key: index + col.name + col.key,
      sorted: sorted
    }, _react["default"].createElement(Formatter, {
      className: col.cellClass,
      row: value,
      value: value[col.key],
      rowIndex: index,
      subrow: false,
      expand: expand,
      expanded: expanded
    }));
  })), shouldShowSubRows && value.subRows.map(function (subValue, subRowIndex) {
    return _react["default"].createElement(RowDiv, {
      key: "".concat(index, "-").concat(subRowIndex),
      height: rowHeight,
      style: subRowStylesGetter(index, value, subRowIndex, subValue) || rowStyle
    }, expandable ? _react["default"].createElement(_SubrowButton.SubRowButtonHolder, null) : null, showCheckbox ? _react["default"].createElement(_SubrowButton.SubRowButtonHolder, null) : null, columns.map(function (col, index) {
      var Formatter = col.formatter ? col.formatter : _TextFormatter["default"];
      var sorted = sortDirection !== _SortIcon.NO_DIRECTION && sortColumn === col.name;
      var width = columnSizes[index] ? columnSizes[index] : col.width;
      return _react["default"].createElement(BodyCell, {
        height: rowHeight,
        width: width,
        key: index + col.name + col.key,
        sorted: sorted
      }, _react["default"].createElement(Formatter, {
        className: col.cellClass,
        row: subValue,
        value: subValue[col.key],
        rowIndex: index,
        subrow: true
      }));
    }));
  }), !!expanded && !!expansion && _react["default"].createElement(ExpansionHolder, {
    id: "".concat(rowPrefix, "-").concat(index)
  }, _react["default"].createElement(ExpansionElement, {
    value: value
  }, "expansion")));
};

RowData.propTypes = {
  index: _propTypes["default"].number.isRequired,
  columns: _ColumnPropTypes["default"].isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]).isRequired,
  rowPrefix: _propTypes["default"].string,
  rowStyle: _propTypes["default"].object,
  rowHeight: _propTypes["default"].number,
  expanded: _propTypes["default"].bool,
  sortColumn: _propTypes["default"].string,
  sortDirection: _propTypes["default"].string,
  hasSubRows: _propTypes["default"].bool,
  columnSizes: _propTypes["default"].arrayOf(_propTypes["default"].number),
  expansion: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].node, _propTypes["default"].func, _propTypes["default"].string, _propTypes["default"].object]),
  displayExpansionButton: _propTypes["default"].bool,
  recompute: _propTypes["default"].func,
  tableExpanded: _propTypes["default"].func,
  expandable: _propTypes["default"].bool,
  subRowStylesGetter: _propTypes["default"].func,
  showCheckbox: _propTypes["default"].bool,
  isRowSelected: _propTypes["default"].bool,
  onRowSelectionChange: _propTypes["default"].func,
  isRowDisabled: _propTypes["default"].bool,
  canSelect: _propTypes["default"].func,
  expandCallback: _propTypes["default"].func,
  onRowClick: _propTypes["default"].func
};
RowData.defaultProps = {
  rowPrefix: "",
  rowStyle: {},
  rowHeight: 35,
  expanded: false,
  sortColumn: null,
  sortDirection: null,
  hasSubRows: false,
  columnSizes: [],
  expansion: null,
  displayExpansionButton: true,
  recompute: function recompute() {},
  tableExpanded: function tableExpanded() {
    return false;
  },
  expandable: true,
  subRowStylesGetter: function subRowStylesGetter() {},
  showCheckbox: false,
  isRowSelected: false,
  onRowSelectionChange: function onRowSelectionChange() {},
  isRowDisabled: false,
  canSelect: function canSelect() {
    return true;
  },
  expandCallback: function expandCallback() {},
  onRowClick: null
};

var Row = function Row(_ref3) {
  var index = _ref3.index,
      rowPrefix = _ref3.rowPrefix,
      style = _ref3.style,
      rowHeight = _ref3.rowHeight,
      rowStyle = _ref3.rowStyle,
      isVirtualized = _ref3.isVirtualized,
      onRowClick = _ref3.onRowClick,
      rest = _objectWithoutProperties(_ref3, ["index", "rowPrefix", "style", "rowHeight", "rowStyle", "isVirtualized", "onRowClick"]);

  return _react["default"].createElement("div", {
    key: rowPrefix + index,
    style: style
  }, isVirtualized ? _react["default"].createElement(RowData, _extends({
    index: index,
    rowPrefix: rowPrefix,
    rowHeight: rowHeight,
    onRowClick: onRowClick,
    rowStyle: rowStyle
  }, rest)) : _react["default"].createElement(_reactOnScreen["default"], {
    partialVisibility: true,
    once: true
  }, function (_ref4) {
    var isVisible = _ref4.isVisible;
    return isVisible ? _react["default"].createElement(RowData, _extends({
      index: index,
      rowPrefix: rowPrefix,
      rowHeight: rowHeight,
      rowStyle: rowStyle
    }, rest)) : _react["default"].createElement(DefaultRow, {
      rowHeight: rowHeight,
      rowStyle: rowStyle
    });
  }));
};

Row.propTypes = {
  index: _propTypes["default"].number.isRequired,
  rowPrefix: _propTypes["default"].string,
  style: _propTypes["default"].object,
  rowStyle: _propTypes["default"].object,
  rowHeight: _propTypes["default"].number,
  isVirtualized: _propTypes["default"].bool,
  onRowClick: _propTypes["default"].func
};
Row.defaultProps = {
  rowPrefix: "",
  style: {},
  rowStyle: {},
  rowHeight: 35,
  isVirtualized: true,
  onRowClick: null
};
var _default = Row;
exports["default"] = _default;